import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  IStoreProductsStateError,
  IStoreProductsStateSuccess,
  IUpsertProductPayload,
  ProductModel,
} from '@boxx/store-core';
import { Store } from '@ngrx/store';
import * as fromReducer from '../store.reducer';
import * as fromProductsActions from './store-products.actions';
import * as fromSelectors from './store-products.selectors';

@Injectable()
export class StoreProductsStore
  implements
    IStoreBase<
      ProductModel[],
      IStoreProductsStateSuccess,
      IStoreProductsStateError
    >
{
  constructor(public store: Store<fromReducer.IStoreState>) {}

  get loading$() {
    return this.store.select(fromSelectors.getStoreProductsIsLoading);
  }
  get data$() {
    return this.store.select(fromSelectors.getStoreProductsData);
  }
  get fetched$() {
    return this.store.select(fromSelectors.getStoreProductsHasBeenFetched);
  }
  get error$() {
    return this.store.select(fromSelectors.getStoreProductsError);
  }
  get success$() {
    return this.store.select(fromSelectors.getStoreProductsSuccess);
  }

  fetch = () =>
    this.store.dispatch(fromProductsActions.loadProductsBeginAction());

  create = (payload: IUpsertProductPayload) =>
    this.store.dispatch(
      fromProductsActions.createProductBeginAction({ payload })
    );

  update = (payload: IUpsertProductPayload) =>
    this.store.dispatch(
      fromProductsActions.updateProductBeginAction({ payload })
    );

  delete = (id: number) =>
    this.store.dispatch(fromProductsActions.deleteProductBeginAction({ id }));

    getSingleProduct = (id: number) =>
    this.store.dispatch(
      fromProductsActions.loadSingleProductBeginAction( {id} )
    );

    getUpdatedProduct = (id: number) =>
    this.store.dispatch(
      fromProductsActions.loadUpdatedProductBeginAction( {id} )
    );

    deleteProductImage = (payload: any) =>
    this.store.dispatch(
      fromProductsActions.deleteImageProductBeginAction({ payload })
    );
}
